import { isNil } from 'lodash'

import { useGetGroupQuery } from 'store/api/yay/group'
import { useCurrentUser } from 'store/api/yay/user'

export const useGroupUserRole = ({ groupId }) => {
  const groupRes = useGetGroupQuery(
    {
      groupId: groupId?.toString?.(),
    },
    {
      skip: isNil(groupId),
    }
  )

  const currentUserId = useCurrentUser().data?.id

  const isGroupOwner = currentUserId === groupRes?.data?.owner?.id

  const groupUserRole = isGroupOwner
    ? 'owner'
    : groupRes?.data?.moderator_ids?.includes(currentUserId)
    ? 'moderator'
    : groupRes?.data?.is_joined
    ? 'member'
    : 'non_member'

  return groupUserRole
}
